<template>
    <div>
      <b-tabs content-class="mt-3">
        <b-tab title="Creditcard" active>
          <b-form-group>
            <label>Name on Card</label>
            <b-input/>
          </b-form-group>
          <b-form-group>
            <label>Debit/Credit card number:</label>
            <div class="input-group mb-0">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1"><img style="max-width:30px;" :src="cardBrandClass"/></span>
              </div>
              <input ref="cardNumInput" :data-error="(cardErrors.cardNumber)?true:false" @change="validate" v-model="cardNumber" type="tel" class="form-control" placeholder="#### #### #### ####" v-cardformat:formatCardNumber>
            </div>
            <div v-if="cardErrors.cardNumber" class="error">
              <small>{{ cardErrors.cardNumber }}</small>
            </div>
          </b-form-group>

          <div class="row">
            <div class="col-6 col-md-4">
              <b-form-group>
                <label>Expiration date</label>
                <input ref="cardExpInput" id="card-exp" :data-error="(cardErrors.cardExpiry)?true:false" v-model="cardExpiry" @change="validate" maxlength="10" class="form-control" v-cardformat:formatCardExpiry>
                <div v-if="cardErrors.cardExpiry" class="error">
                  <small>{{ cardErrors.cardExpiry }}</small>
                </div>
              </b-form-group>
            </div>
                  <div class="col-6 col-md-4">
                    <b-form-group>
                      <label>Security code:</label>
                      <input ref="cardCvcInput" :data-error="(cardErrors.cardCvc)?true:false" v-model="cardCvc" @change="validate" class="form-control" v-cardformat:formatCardCVC>
                      <div v-if="cardErrors.cardCvc" class="error">
                        <small>{{ cardErrors.cardCvc }}</small>
                      </div>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group>
                      <label>Billing ZIP code</label>
                      <input v-model="cardPostal" class="form-control" @change="validate">
                    </b-form-group>
                  </div>
                </div>
              </b-tab>
              <b-tab title="PayPal" disabled>
                  <b-alert variant="info" show>We're sorry, PayPal is unavailable in your region.</b-alert>
              </b-tab>
            </b-tabs>
    </div>
</template>

<script>
    import unknown from 'payment-icons/min/outline/default.svg';
    import visa from 'payment-icons/min/flat/visa.svg';
    import mastercard from 'payment-icons/min/flat/mastercard.svg';
    import amex from 'payment-icons/min/flat/amex.svg';
    import discover from 'payment-icons/min/flat/discover.svg';
    import diners from 'payment-icons/min/flat/diners.svg';
    import jcb from 'payment-icons/min/flat/jcb.svg';

    export default {
        name: 'Creditcard',
        computed: {
            cardBrandClass(){
            return this.getBrandClass(this.cardBrand);
            }
        },
        data() {
            return {
                cardNumber: null,
                cardExpiry: null,
                cardCvc: null,
                cardPostal: null,
                cardErrors: {},
                // declaring card-brand in data{} enables card brand name/classes.
                cardBrand: null,
                // demo only
            }
        },
        methods: {
            validate: function(){

            // init
            this.cardErrors = {};
            
            // validate card number
            if(!this.$cardFormat.validateCardNumber(this.cardNumber)){
                this.cardErrors.cardNumber = "Invalid Credit Card Number.";
            }

            // validate card expiry
            if (!this.$cardFormat.validateCardExpiry(this.cardExpiry)) {
                this.cardErrors.cardExpiry = "Invalid Expiration Date.";
            }

            // validate card CVC
            if (!this.$cardFormat.validateCardCVC(this.cardCvc)) {
                this.cardErrors.cardCvc = "Invalid CVC.";
            }

            },
            prefill: function(ccNum){
            this.cardNumber = ccNum;
            this.$cardFormat.setCardType({
                currentTarget : this.$refs.cardNumInput,
                value: ccNum
            });
            },
            getBrandClass: function (brand) {
              let icon = '';
              brand = brand || 'unknown';
              let cardBrandToClass = {
                  'visa': visa,
                  'mastercard': mastercard,
                  'amex': amex,
                  'discover': discover,
                  'diners': diners,
                  'jcb': jcb,
                  'unknown': unknown,
              };
              if (cardBrandToClass[brand]) {
                  icon = cardBrandToClass[brand];
              }

              return icon;
            }
        },
        watch: {
            // handle auto-focus to next field
            // Note: since CVC can be 3 OR 4 digits we don't watch it
            cardNumber: function(val){
            if(this.$cardFormat.validateCardNumber(val)){
                this.$refs.cardExpInput.focus();
            }
            },
            cardExpiry: function (val) {
            if (this.$cardFormat.validateCardExpiry(val)) {
                this.$refs.cardCvcInput.focus();
            }
            }
        },
        mounted(){
            this.$refs.cardNumInput.focus();
        } 
    }
</script>

<style scoped>

</style>
